// src/store/modules/snackbar.js
export default {
    namespaced: true,

    state: {
        snackbar: {
            show: false,
            title: "Success!",
            color: "success",
        }
    },

    mutations: {
        SHOW_SNACKBAR(state, payload) {
            state.snackbar.title = payload.title;
            state.snackbar.color = payload.color;
            state.snackbar.show = true;
        },
        HIDE_SNACKBAR(state) {
            state.snackbar.show = false;
            state.snackbar.title = "";
            state.snackbar.color = "success";
        }
    },

    actions: {
        showSnackbar({ commit }, payload) {
            commit("SHOW_SNACKBAR", payload);
            setTimeout(() => commit("HIDE_SNACKBAR"), 8000);
        },
        hideSnackbar({ commit }) {
            commit("HIDE_SNACKBAR");
        }
    }
};
